export const CONTENT_STORAGE_URL = 'https://content-storage.voicemod.net';
